import React, { useEffect, useState } from 'react';
import SearchReservation from 'components/BusinessLogic/SearchReservationByBookingNumber';
import PropTypes from 'prop-types';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Search({ className })
{
    const [showBookingSearch, setShowBookingSearch] = useState(false);

    useEffect(() =>
    {
        if (showBookingSearch)
        {
            document.body.classList.add('tw-overflow-hidden');
            return;
        }

        document.body.classList.remove('tw-overflow-hidden');
    }, [showBookingSearch]);

    return (
        <div className={className}>
            <button className="tw-w-full tw-bg-white dark:tw-text-white tw-py-2 tw-px-4 tw-border tw-border-neutral-200 tw-outline-none tw-transition-all tw-text-neutral-600 hover:tw-text-neutral-800 hover:tw-border-primary-default focus:tw-text-neutral-800 focus:tw-border-primary-default dark:tw-bg-neutral-600 dark:tw-border-gray-400 tw-h-fit tw-rounded tw-overflow-hidden tw-relative tw-mx-0" type="button" onClick={() => setShowBookingSearch(true)} onFocus={() => setShowBookingSearch(true)}>
                <FontAwesomeIcon size="sm" icon={faSearch} /> Quote ID, Booking Number, Traveler Name
            </button>
            {showBookingSearch && (
                <SearchReservation onClose={() => setShowBookingSearch(false)} />
            )}
        </div>
    );
}

Search.propTypes = {
    className: PropTypes.string,
};

Search.defaultProps = {
    className: '',
};

export default Search;
